<template>
  <div class="td-doctor-home">
    <td-divider style="margin-top:100px;">页面正在配置中...</td-divider>
  </div>
</template>

<script>
export default {
  name: "TianDingDoctorHomeComponent"
};
</script>



// WEBPACK FOOTER //
// src/views/home/index.vue